module.exports = __webpack_public_path__ + "img/img_20@2x.b62a6e9a.png";